export class Web3BaseWallet extends Array {
    constructor(accountProvider) {
        super();
        this._accountProvider = accountProvider;
    }
}
//# sourceMappingURL=web3_base_wallet.js.map